import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-973101de"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nome: ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Email: ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "CPF: ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fone/Whatsapp: ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Endereço: ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Complemento: ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Referência: ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "CEP: ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "center" }, "Cliente não encontrado", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { IonContent, IonGrid, IonRow, IonCol , IonButton} from '@ionic/vue';
import { reactive , computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { key } from '../store';



export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutClienteData',
  setup(__props) {

const store = useStore(key);
const router = useRouter();

const clienteData = reactive(store.state.user[0]);
const enderecoData = reactive(store.state.user[1]);

// clienteData = store.state.user[0];
// enderecoData = store.state.user[0];
// const userData = reactive(store.state.user);

const cep1 = computed(()=>{
    if (enderecoData.cep){
        return enderecoData.cep.substring(0,5);
    } else {
        return '';
    }
})

const cep2 = computed(()=>{
    if (enderecoData.cep){
        return enderecoData.cep.substring(5,);
    } else {
        return '';
    }
})

function openChangeClienteData(){
    router.push({name:'chechoutalteradados'})
}

function confirmaClienteData(){
    router.push({name:'checkoutfinal'})
}

function goBack(){
    store.dispatch('clearUserStore');
    router.go(-1);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), null, {
    default: _withCtx(() => [
      (clienteData != undefined)
        ? (_openBlock(), _createBlock(_unref(IonGrid), { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, [
                        _hoisted_1,
                        _createTextVNode(_toDisplayString(clienteData.nome.toUpperCase()), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_2,
                        _createTextVNode(_toDisplayString(clienteData.email), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_3,
                        _createTextVNode(_toDisplayString(clienteData.cpf), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_4,
                        _createTextVNode("(" + _toDisplayString((clienteData.telefone1).substring(0,2)) + ")" + _toDisplayString((clienteData.telefone1).substring(2,)), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_5,
                        _createTextVNode(_toDisplayString(enderecoData.endereco) + ", " + _toDisplayString(enderecoData.numero), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_6,
                        _createTextVNode(_toDisplayString(enderecoData.complemento), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _hoisted_7,
                        _createTextVNode(_toDisplayString(enderecoData.referencia), 1)
                      ]),
                      _createElementVNode("p", null, _toDisplayString(enderecoData.bairro) + " - " + _toDisplayString(enderecoData.cidade) + " - " + _toDisplayString(enderecoData.uf), 1),
                      _createElementVNode("p", null, [
                        _hoisted_8,
                        _createTextVNode(_toDisplayString(_unref(cep1)) + "-" + _toDisplayString(_unref(cep2)), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        expand: "block",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (confirmaClienteData()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Confirma os dados ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        expand: "block",
                        color: "medium",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (openChangeClienteData()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Alterar os dados ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_unref(IonGrid), { key: 1 }, {
            default: _withCtx(() => [
              _hoisted_9,
              _createVNode(_unref(IonButton), { expand: "block" }, {
                default: _withCtx(() => [
                  _createTextVNode("Fazer um novo cadastro")
                ]),
                _: 1
              }),
              _hoisted_10,
              _createVNode(_unref(IonButton), {
                expand: "block",
                color: "medium",
                onClick: goBack
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Tentar novamente")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}
}

})